import { MouseEvent, useState } from "react";
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import TruckComplianceMatrixTable from "../../components/Fleet/TruckComplianceMatrixTable/TruckComplianceMatrixTable";
import TrailerComplianceMatrixTable from "../../components/Fleet/TrailerComplianceMatrixTable/TrailerComplianceMatrixTable";

const CompliancePage = () => {
  const [assetType, setAssetType] = useState<"truck" | "trailer">("truck");

  const handleAssetTypeChange = (
    _event: MouseEvent<HTMLElement>,
    value: "truck" | "trailer" | null,
  ) => {
    if (value) {
      setAssetType(value);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" fontWeight={600} mb={2}>
        {assetType === "truck"
          ? "Truck Compliance Matrix"
          : "Trailer Compliance Matrix"}
      </Typography>

      <ToggleButtonGroup
        color="primary"
        exclusive
        value={assetType}
        onChange={handleAssetTypeChange}
        sx={{ mb: 2 }}
      >
        <ToggleButton value="truck">Trucks</ToggleButton>
        <ToggleButton value="trailer">Trailers</ToggleButton>
      </ToggleButtonGroup>

      {assetType === "truck" ? (
        <TruckComplianceMatrixTable />
      ) : (
        <TrailerComplianceMatrixTable />
      )}
    </Box>
  );
};

export default CompliancePage;
